export const CONTROL_SETTINGS_STORAGE_KEY = "breakroom-controls-v1";

export interface ControlSettings {
  alwaysShowTouchControls: boolean;
  showGameChrome: boolean;
}

export const DEFAULT_CONTROL_SETTINGS: ControlSettings = {
  alwaysShowTouchControls: false,
  showGameChrome: true
};

type Listener = (settings: ControlSettings) => void;

const listeners = new Set<Listener>();
let settings = loadControlSettings();

export function parseControlSettings(raw: unknown): ControlSettings {
  const source = raw && typeof raw === "object" ? (raw as Record<string, unknown>) : {};
  return {
    alwaysShowTouchControls: source.alwaysShowTouchControls === true,
    showGameChrome:
      typeof source.showGameChrome === "boolean"
        ? source.showGameChrome
        : DEFAULT_CONTROL_SETTINGS.showGameChrome
  };
}

export function getControlSettings(): ControlSettings {
  return { ...settings };
}

export function setControlSettings(patch: Partial<ControlSettings>): ControlSettings {
  settings = parseControlSettings({ ...settings, ...patch });
  persistControlSettings(settings);
  for (const listener of listeners) listener(getControlSettings());
  return getControlSettings();
}

export function subscribeControlSettings(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function loadControlSettings(): ControlSettings {
  try {
    const stored = globalThis.localStorage?.getItem(CONTROL_SETTINGS_STORAGE_KEY);
    if (!stored) return { ...DEFAULT_CONTROL_SETTINGS };
    return parseControlSettings(JSON.parse(stored));
  } catch {
    return { ...DEFAULT_CONTROL_SETTINGS };
  }
}

function persistControlSettings(next: ControlSettings): void {
  try {
    globalThis.localStorage?.setItem(CONTROL_SETTINGS_STORAGE_KEY, JSON.stringify(next));
  } catch {
    // Private mode and missing storage should not block control options.
  }
}
